export const APPLICATION_TYPE_URLS = {
  APPLICATION_REQ: '/application/request',
  APPLICATION_REQ_TYPE_ALL: '/application/request/withOptions',
  APPLICATION_REQ_OPTION_ALL: '/application/request-option/withProducts',
  APPLICATION_REQ_OPTION: '/application/request-option',
  GET_ALL_PRODUCT_TYPE: '/application/request',
  REMOVE_PRODUCT_MAPPING: '/application/request-option/delete_mapping_product',
  GET_ALL_PRODUCT_OPTION_TYPE: '/application/request-option'
};
